import InitApi from "api/InitApi";
import {
	BOOK_UPLOAD_STEPS,
	buildFormData,
	splitBookFileFields,
	uploadBookFiles,
} from "api/BookResource/bookFileUpload";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import toast from "react-hot-toast";
import { deleteEmptyObjects } from "utils";
import ServerErrors from "components/SeverErrors";

const useAddPhysicalBook = ({ onStepChange } = {}) => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const addBook = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");
		const body = deleteEmptyObjects(obj);
		const { files, metadata } = splitBookFileFields(body);
		const hasFiles = Boolean(files.book_cover);

		try {
			onStepChange?.(BOOK_UPLOAD_STEPS.SAVING_DETAILS);

			const createResponse = await instance.post(
				"/books/physical",
				buildFormData(metadata)
			);
			const bookId = createResponse?.data?.data?.id;

			if (bookId && hasFiles) {
				onStepChange?.(BOOK_UPLOAD_STEPS.UPLOADING_FILES);
				await uploadBookFiles(instance, bookId, files);
			}

			await Promise.all([
				queryClient.invalidateQueries("books"),
				queryClient.invalidateQueries("myUploadedBooks"),
			]);

			return createResponse?.data;
		} finally {
			onStepChange?.(null);
		}
	};

	return useMutation(addBook, {
		onSuccess: async () => {
			toast.success("Book added successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useAddPhysicalBook;
